import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken, getSession } from 'utils/token';
import Configs from 'config/config';
// import dispatchBoard from '../dispatchBoard/api';

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const env = process.env.NODE_ENV;
export const loginUser = createAsyncThunk(
  'login',
  async (credentials, thunkAPI) => {
    try {
      const response = await fetch(`${Configs[env].BACKEND_MFA_HOST}/login/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });
      let data = await response.json();

      if (response.status === 200 && data.access_type === 'web') {
        const token = data.token;
        const session = data.session;

        const resIsAuth = await thunkAPI
          .dispatch(isAuthenUser({ token, session }))
          .unwrap();

        return { ...resIsAuth, token, session };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
    }
  },
);
export const passwordRecovery = createAsyncThunk(
  'password/recovery',
  async (email, thunkAPI) => {
    try {
      const response = await fetch(
        `${Configs[env].BACKEND_HOST}/password/recovery/`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(email),
        },
      );
      let data = await response.json();
      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
    }
  },
);
export const logoutUser = createAsyncThunk('logout', async (_, thunkAPI) => {
  try {
    let token = getToken();
    let session = getSession();
    localStorage.removeItem('token');
    localStorage.removeItem('session');

    const response = await fetch(`${Configs[env].BACKEND_MFA_HOST}/logout/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Session-Token': `Bearer ${session}`,
      },
    });
    let data = await response.json();
    if (response.status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue(data);
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
  }
});

export const isAuthenUser = createAsyncThunk(
  'user/isAuthen',
  async ({ token, session }, thunkAPI) => {
    try {
      if (!token || !session) {
        return thunkAPI.rejectWithValue('No token or session');
      }

      const response = await fetch(`${Configs[env].BACKEND_MFA_HOST}/isauth/`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'X-Session-Token': `Bearer ${session}`,
        },
      });

      const data = await response.json();

      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const resetUserMfa = createAsyncThunk(
  'mfa/disable',
  async ({ token, session, user_id }, thunkAPI) => {
    try {
      if (!token || !session) {
        return thunkAPI.rejectWithValue('No token or session');
      }

      const response = await fetch(
        `${Configs[env].BACKEND_MFA_HOST}/mfa/disable/`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Session-Token': `Bearer ${session}`,
          },
          body: JSON.stringify({
            user_id: user_id,
          }),
        },
      );

      const data = await response.json();

      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
// Define a service using a base URL and expected endpoints
const emptyApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${Configs[env].BACKEND_HOST}`,
    prepareHeaders: (headers) => {
      headers.set('Authorization', `Bearer ${getToken()}`);
      headers.set('X-Session-Token', `Bearer ${getSession()}`);
      return headers;
    },
  }),
  endpoints: () => ({}),
});
const apiWithTag = emptyApi.enhanceEndpoints({
  addTagTypes: ['User', 'Group', 'Notify'],
});
export const rootApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllUsers: builder.query({
      query: () => `users/`,
      providesTags: ['User'],
    }),
    findAllCreateTripNotify: builder.query({
      query: () => `create_trip/notify/draft_dispatch_board/`,
      keepUnusedDataFor: 0,
      providesTags: ['Notify'],
    }),
    findAllTripNotifyIsAck: builder.query({
      query: () => `notify_trip_impact/is_ack/`,
      keepUnusedDataFor: 0,
    }),
    clearNotifyIsAck: builder.mutation({
      query: () => ({
        url: `notify_trip_impact/is_ack/`,
        method: 'PATCH',
      }),
      keepUnusedDataFor: 0,
    }),
    updateNotifyByUser: builder.mutation({
      query: (body) => ({
        url: `notify_trip_impact/read/`,
        method: 'PATCH',
        body: body,
      }),
      keepUnusedDataFor: 0,
    }),
    findAllNotifyByUser: builder.query({
      query: () => `notify_trip_impact/user/`,
      keepUnusedDataFor: 0,
      providesTags: ['Notify'],
    }),
    findDraftDispatchBoardById: builder.query({
      query: (id) => `create_trip/draft_dispatch_board/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Notify', id: result.id }] : ['Notify'];
      },
    }),
    updateStatusDraft: builder.mutation({
      query: (payload) => ({
        url: `create_trip/draft_dispatch_board/${payload.id}/?draft_status=${payload.draft_status}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Notify'],
    }),
    findUserById: builder.query({
      query: (id) => `users/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'User', id: result.id }] : ['User'];
      },
    }),
    createUser: builder.mutation({
      query: (user) => ({
        url: `users/`,
        method: 'POST',
        body: user,
      }),
      invalidatesTags: ['User'],
    }),
    updateUser: builder.mutation({
      query: (user) => ({
        url: `users/${user.id}/`,
        method: 'PATCH',
        body: user,
      }),
      invalidatesTags: ['User'],
    }),
    deleteUser: builder.mutation({
      query: (user) => ({
        url: `users/${user.id}/`,
        method: 'PATCH',
        body: user,
      }),
      invalidatesTags: ['User'],
    }),
    destroyUser: builder.mutation({
      query: (user) => ({
        url: `users/${user.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
    findAllGroups: builder.query({
      query: () => ({
        url: `groups/`,
        method: 'GET',
      }),
      providesTags: ['Group'],
    }),
    findAllGroupsOfCompany: builder.query({
      query: (id) => ({
        url: `groups/?companyId=${id}`,
        method: 'GET',
      }),
      providesTags: ['Group'],
    }),
    findGroupById: builder.query({
      query: (id) => `groups/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Group', id: result.id }] : ['Group'];
      },
    }),
    createGroup: builder.mutation({
      query: (group) => ({
        url: `groups/`,
        method: 'POST',
        body: group,
      }),
      invalidatesTags: ['Group'],
    }),
    updateGroup: builder.mutation({
      query: (group) => ({
        url: `groups/${group.id}/`,
        method: 'PATCH',
        body: group,
      }),
      invalidatesTags: ['Group'],
    }),
    deleteGroup: builder.mutation({
      query: (group) => ({
        url: `groups/${group.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Group'],
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllUsersQuery,
  useFindAllCreateTripNotifyQuery,
  useFindAllTripNotifyIsAckQuery,
  useFindAllNotifyByUserQuery,
  useFindUserByIdQuery,
  useLazyFindDraftDispatchBoardByIdQuery,
  useClearNotifyIsAckMutation,
  useCreateUserMutation,
  useUpdateUserMutation,
  useUpdateNotifyByUserMutation,
  useDeleteUserMutation,
  useDestroyUserMutation,
  useFindAllGroupsQuery,
  useFindAllGroupsOfCompanyQuery,
  useFindGroupByIdQuery,
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useUpdateStatusDraftMutation,
} = rootApi;
